import React, { useEffect, useState } from 'react'
import { useRateLimitContext } from '../../hooks'
import { RATE_LIMIT_DELAY } from '../../consts'
import {
  CableIcon,
  Description,
  ProgressBar,
  ReconnectButton,
  ReconnectingText,
  SubTitle,
  SupportText,
  Title
} from 'pages/rateLimitPage/components'

import styles from './RateLimitedPage.module.scss'

const COUNTDOWN_SECONDS = RATE_LIMIT_DELAY / 1000
const RADIUS = 72
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

export const RateLimitPage = () => {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS)
  const isReady = secondsLeft <= 0
  const { state, actions } = useRateLimitContext()
  const { goBack } = actions

  const colors = state?.colors ?? null

  const bgColor = colors?.channelPrimaryBackgroundColorInverted ?? null
  const textColor = colors?.channelPrimaryColorInverted ?? null

  useEffect(() => {
    if (isReady) {
      goBack()
      return
    }
    const timer = setTimeout(() => setSecondsLeft((prev) => prev - 1), 1000)
    return () => clearTimeout(timer)
  }, [secondsLeft, goBack])

  const dashOffset = CIRCUMFERENCE * (secondsLeft / COUNTDOWN_SECONDS)

  const containerStyle = colors
    ? { backgroundColor: bgColor ?? undefined, color: textColor ?? undefined }
    : undefined

  const ctaButtonStyle = textColor
    ? {
        backgroundColor: textColor,
        borderColor: textColor,
        color: bgColor ?? '#000000'
      }
    : undefined

  return (
    <div className={styles.Container} style={containerStyle}>
      <CableIcon direction="right" />
      <CableIcon direction="left" />
      <Title />
      <SubTitle />
      <Description />
      <ProgressBar
        CIRCUMFERENCE={CIRCUMFERENCE}
        RADIUS={RADIUS}
        dashOffset={dashOffset}
        textColor={textColor}
        isReady={isReady}
        secondsLeft={secondsLeft}
      />
      <ReconnectingText isReady={isReady} secondsLeft={secondsLeft} />
      <ReconnectButton
        isReady={isReady}
        secondsLeft={secondsLeft}
        goBack={goBack}
        ctaButtonStyle={ctaButtonStyle}
      />
      <SupportText />
    </div>
  )
}
